import React from 'react';

import styles from '../Markdown.pcss';

/* Render div instead of p to prevent invalid dom nesting. */
const MarkdownParagraph = (props: {children: React.ReactNode}) => (
    <div className={styles.paragraph}>{props.children}</div>
);

export default MarkdownParagraph;
